import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';

export const HookedResetButton = (props: ChakraV3.ButtonProps) => {
  const { children, ...rest } = props;
  const { formState, reset } = useFormContext();

  return (
    <ChakraV3.Button
      size='sm'
      colorPalette='brand'
      variant='outline'
      onClick={() => reset()}
      disabled={formState.isSubmitting || !formState.isDirty}
      {...rest}
    >
      {children}
    </ChakraV3.Button>
  );
};
